// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".room-schedule-tab[data-v-aea83870]{width:100%;margin-left:auto;margin-right:auto}.room-schedule-tab .current-date[data-v-aea83870]{font-weight:700;font-size:22px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
